<template>
  <ProprietaireRegister />
</template>

<script>
  import ProprietaireRegister from "@/components/ProprietaireRegister.vue";
  export default {
    name: "ProductListPage",
    components: {
      ProprietaireRegister,
    },
    data() {
      return {};
    },
    computed: {},
    mounted() {},
    methods: {},
  };
</script>
